import { OrderNftsBy } from "@/api/nfts/types";
import { OrderDirection } from "@/api/types";

export enum NftSortValues {
  RECENTLY_LISTED = "recently_listed",
  LOW_TO_HIGH = "price_low_to_high",
  HIGH_TO_LOW = "price_high_to_low",
  OLDEST = "oldest",
  NEWEST = "newest",
}
export interface NftSortOption {
  value: NftSortValues;
  label: string;
  order: OrderNftsBy;
  orderDirection: OrderDirection;
  isOnSale: boolean;
}

export const NFT_LIST_OPTIONS: NftSortOption[] = [
  {
    label: "Recently listed",
    value: NftSortValues.RECENTLY_LISTED,
    order: OrderNftsBy.ListedAt,
    orderDirection: OrderDirection.DESC,
    isOnSale: true,
  },
  {
    label: "Price low to high",
    value: NftSortValues.LOW_TO_HIGH,
    order: OrderNftsBy.Price,
    orderDirection: OrderDirection.ASC,
    isOnSale: true,
  },
  {
    label: "Price high to Low",
    value: NftSortValues.HIGH_TO_LOW,
    order: OrderNftsBy.Price,
    orderDirection: OrderDirection.DESC,
    isOnSale: true,
  },
  {
    label: "Oldest",
    value: NftSortValues.OLDEST,
    order: OrderNftsBy.CreatedAt,
    orderDirection: OrderDirection.ASC,
    isOnSale: false,
  },
  {
    label: "Newest",
    value: NftSortValues.NEWEST,
    order: OrderNftsBy.CreatedAt,
    orderDirection: OrderDirection.DESC,
    isOnSale: false,
  },
];
